import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { common } from '@ocean/ui'
import trainingLibraryRoutes from 'modules/trainingLibrary/TrainingLibrary/routing/routes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const CertificateDetails = lazy(
  () =>
    import(
      /* webpackChunkName: "ActivityDetailsCertificateDetails" */ 'modules/activityDetails/CertificateDetails/pages/CertificateDetails'
    )
)

const CertificateDetailsRouting = () => (
  <Suspense fallback={<RouteChangeProgress />}>
    <Switch>
      <Route exact path={`${routes.root}/:certificateId`} component={CertificateDetails} />
      <Redirect path='*' to={trainingLibraryRoutes.root} />
    </Switch>
  </Suspense>
)

export default CertificateDetailsRouting
